"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormDesigner = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var mithril_component_1 = require("../../components/mithril.component");
var notification_service_1 = require("../../components/notification.toast/notification.service");
var spinner_1 = require("../../components/spinner/spinner");
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var page_1 = require("../../page/page");
var services_1 = require("../../services");
var store_1 = require("../../store");
var form_field_editor_1 = require("./editor/form.field.editor");
var form_field_editor_form_1 = require("./editor/form.field.editor.form");
var form_field_editor_height_1 = require("./editor/form.field.editor.height");
var form_field_editor_nested_list_1 = require("./editor/form.field.editor.nested.list");
var form_field_editor_select_list_1 = require("./editor/form.field.editor.select.list");
var form_field_editor_subform_1 = require("./editor/form.field.editor.subform");
var form_field_editor_vertical_separation_1 = require("./editor/form.field.editor.vertical.separation");
var form_designer_style_1 = require("./form.designer.style");
(0, theme_1.addStyles)(form_designer_style_1.Style);
var FormDesigner = /** @class */ (function (_super) {
    tslib_1.__extends(FormDesigner, _super);
    function FormDesigner() {
        var _this = _super.call(this) || this;
        _this.isEditing = false;
        _this.isSaving = false;
        _this.selectedFieldId = null;
        _this.scrollToFieldId = null;
        _this.fields = {};
        services_1.Services.Window.bindNavigateAway(i18n_1.T.DISCARD_CHANGES_CONFIRM, _this.checkExit);
        return _this;
    }
    Object.defineProperty(FormDesigner.prototype, "nodes", {
        get: function () {
            return (0, mithril_1.m)('div', { className: "".concat(form_designer_style_1.CSS.container, " ").concat(this.isEditing ? form_designer_style_1.CSS.isEditing : form_designer_style_1.CSS.isReadOnly) }, [
                this.viewHeader(),
                (0, mithril_1.m)('div', { className: form_designer_style_1.CSS.content }, [
                    this.viewFields(),
                    this.viewInfo()
                ])
            ]);
        },
        enumerable: false,
        configurable: true
    });
    FormDesigner.prototype.onRemove = function () {
        _super.prototype.onRemove.call(this);
        services_1.Services.Window.unbindNavigateAway(this.checkExit);
        var editState = this.editState;
        if (editState != null) {
            this.editState.destroy();
        }
    };
    FormDesigner.prototype.setForm = function (form) {
        this.form = store_1.AppStore.Form.edit(form).form;
        // After saving a new form, clear the edit state.
        // Use the new form edit state despite the versions being the same.
        if (this.form.id == null && form.id != null) {
            store_1.AppStore.Form.clearEdit(form);
            this.form = store_1.AppStore.Form.edit(form).form;
        }
        this.reset();
    };
    FormDesigner.prototype.setEditing = function (isEditing) {
        this.isEditing = isEditing;
    };
    Object.defineProperty(FormDesigner.prototype, "editState", {
        get: function () {
            if (this.isEditing) {
                return store_1.AppStore.Form.edit(this.form);
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    FormDesigner.prototype.viewHeader = function () {
        var _this = this;
        return (0, mithril_1.m)('div', { className: form_designer_style_1.CSS.header }, [
            (0, mithril_1.m)('h6', (0, i18n_1.Translate)(i18n_1.T.FORM_EDIT_TITLE)),
            (0, mithril_1.m)('button', {
                className: 'mdl-button mdl-button--raised mdl-button--accent',
                disabled: !this.canSave,
                onclick: function () { return _this.save(); }
            }, this.isSaving ? spinner_1.Spinner.view() : (0, i18n_1.Translate)(i18n_1.T.SAVE))
        ]);
    };
    FormDesigner.prototype.viewFields = function () {
        var form = this.form;
        if (this.selectedFieldId == null) {
            this.selectedFieldId = form.fieldId;
        }
        return (0, mithril_1.m)('div', { className: form_designer_style_1.CSS.field.container }, this.viewField(form));
    };
    FormDesigner.prototype.viewInfo = function () {
        if (this.selectedFieldId == null || this.fields[this.selectedFieldId] == null) {
            return (0, mithril_1.m)('div', { className: form_designer_style_1.CSS.info.container });
        }
        return (0, mithril_1.m)('div', { className: form_designer_style_1.CSS.info.container }, this.fields[this.selectedFieldId].viewInfo());
    };
    FormDesigner.prototype.createEditor = function (f) {
        if (f === this.form) {
            return new form_field_editor_form_1.FormFieldEditorForm(this, f);
        }
        if (core_shared_1.FormModelFieldSubForm.isSubForm(f)) {
            return new form_field_editor_subform_1.FormFieldEditorSubForm(this, f);
        }
        if (core_shared_1.FormModelFieldNestedList.isNestedList(f)) {
            return new form_field_editor_nested_list_1.FormFieldEditorNestedList(this, f);
        }
        if (core_shared_1.FormModelFieldSelectList.isSelectList(f)) {
            return new form_field_editor_select_list_1.FormFieldEditorSelectList(this, f);
        }
        if (f.type === core_api_1.IkeFieldType.HEIGHT) {
            return new form_field_editor_height_1.FormFieldEditorHeight(this, f);
        }
        if (f.type === core_api_1.IkeFieldType.VERTICAL_SEPARATION) {
            return new form_field_editor_vertical_separation_1.FormFieldEditorVerticalSeparation(this, f);
        }
        return new form_field_editor_1.FormFieldEditor(this, f);
    };
    FormDesigner.prototype.createField = function (form, type) {
        var field = form.Mutator.create(type, core_shared_1.IkeId.generate());
        this.setSelected(field);
        this.setScrollToField(field);
    };
    FormDesigner.prototype.setScrollToField = function (field) {
        if (field == null) {
            this.scrollToFieldId = null;
        }
        else {
            this.scrollToFieldId = field.fieldId;
        }
    };
    FormDesigner.prototype.reset = function () {
        if (this.isEditing) {
            this.editState.reset();
        }
        for (var _i = 0, _a = Object.keys(this.fields); _i < _a.length; _i++) {
            var fieldId = _a[_i];
            var fieldState = this.fields[fieldId];
            fieldState.state.destroy();
        }
        this.fields = {};
        this.setSelected(this.form);
    };
    Object.defineProperty(FormDesigner.prototype, "canSave", {
        get: function () {
            if (this.isEditing) {
                return this.editState.isDirty && !this.isSaving && this.editState.canSubmit;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    FormDesigner.prototype.checkExit = function () {
        return this.editState.isDirty;
    };
    FormDesigner.prototype.getEditor = function (f) {
        var editor = this.fields[f.fieldId];
        if (editor == null) {
            editor = this.fields[f.fieldId] = this.createEditor(f);
            this.editState.inputStates.add(editor.state);
        }
        return editor;
    };
    FormDesigner.prototype.viewField = function (f) {
        var _this = this;
        var nodes = this.getEditor(f).viewTree();
        if (this.scrollToFieldId === f.fieldId) {
            nodes.attrs.oncreate = function (ctx) {
                ctx.dom.scrollIntoView();
                _this.setScrollToField(null);
            };
        }
        return nodes;
    };
    FormDesigner.prototype.setSelected = function (f) {
        if (f == null) {
            this.selectedFieldId = null;
        }
        else {
            this.selectedFieldId = f.fieldId;
        }
    };
    FormDesigner.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var selectedFieldId, isNewForm, newForm, selectedField, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.editState == null || !this.canSave) {
                            return [2 /*return*/];
                        }
                        this.setSaving(true);
                        selectedFieldId = null;
                        if (this.selectedFieldId != null) {
                            selectedFieldId = this.selectedFieldId.split(':').pop();
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        isNewForm = this.form.id == null;
                        return [4 /*yield*/, services_1.Services.Form.save(this.editState.form)];
                    case 2:
                        newForm = _a.sent();
                        this.setForm(newForm);
                        if (isNewForm) {
                            services_1.Services.Route.go(page_1.IkePageName.formEdit, { version: newForm.version });
                        }
                        else {
                            services_1.Services.Route.setParam('version', newForm.version);
                            if (selectedFieldId != null) {
                                selectedField = newForm.findField(selectedFieldId);
                                this.setSelected(selectedField);
                            }
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        notification_service_1.NotificationService.error({ key: i18n_1.T.FORM_ERROR_SAVING });
                        services_1.Services.Log.Logger.error(e_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.setSaving(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    FormDesigner.prototype.setSaving = function (isSaving) {
        this.isSaving = isSaving;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], FormDesigner.prototype, "isEditing", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FormDesigner.prototype, "isSaving", void 0);
    tslib_1.__decorate([
        mobx_1.observable.ref
    ], FormDesigner.prototype, "form", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FormDesigner.prototype, "selectedFieldId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FormDesigner.prototype, "scrollToFieldId", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FormDesigner.prototype, "setForm", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormDesigner.prototype, "setEditing", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormDesigner.prototype, "createField", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormDesigner.prototype, "setScrollToField", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormDesigner.prototype, "reset", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], FormDesigner.prototype, "checkExit", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormDesigner.prototype, "setSelected", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormDesigner.prototype, "setSaving", null);
    return FormDesigner;
}(mithril_component_1.IMithrilStateComponent));
exports.FormDesigner = FormDesigner;
//# sourceMappingURL=form.designer.js.map